import { SVGProps } from 'react';

export interface IconDollarProps extends SVGProps<SVGSVGElement> {
	className?: string;
	testId?: string;
}

const IconDollar = (props: IconDollarProps) => {
	const { testId = 'IconDollar', className, ...remainingProps } = props;

	return (
		<svg
			data-testid={testId}
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 56 56"
			aria-label="Dollar Sign Icon"
			className={className}
			{...remainingProps}
		>
			<path d="M28 8.75C17.3688 8.75 8.75 17.3688 8.75 28C8.75 38.6313 17.3688 47.25 28 47.25C38.6313 47.25 47.25 38.6313 47.25 28C47.25 17.3688 38.6313 8.75 28 8.75ZM28 12.25C36.6984 12.25 43.75 19.3016 43.75 28C43.75 36.6984 36.6984 43.75 28 43.75C19.3016 43.75 12.25 36.6984 12.25 28C12.25 19.3016 19.3016 12.25 28 12.25ZM27.9436 18.9766C27.6356 18.9766 27.4309 19.1711 27.4309 19.5098V20.7915C24.5705 20.935 22.5193 22.5349 22.5193 25.0059C22.5193 27.2214 23.9859 28.4208 26.6721 29.0254L27.4309 29.1997V32.9321C26.1385 32.8193 25.4929 32.2348 25.1648 31.4351C24.8778 30.8401 24.4474 30.5122 23.8113 30.5122C22.9704 30.5122 22.468 31.0144 22.468 31.7529C22.468 31.9472 22.5088 32.1627 22.5911 32.3989C23.0933 33.8961 24.7954 35.1159 27.4309 35.2393V36.4902C27.4309 36.8289 27.6356 37.0217 27.9436 37.0217C28.2516 37.0217 28.4563 36.8272 28.4563 36.4885V35.2375C31.4094 35.0634 33.532 33.4945 33.532 30.9001C33.532 28.6549 32.0657 27.527 29.2561 26.8909L28.4563 26.7166V23.1072C29.4407 23.2411 30.0867 23.7446 30.4866 24.5854C30.8147 25.1804 31.2552 25.4775 31.8914 25.4775C32.671 25.4775 33.1833 25.0362 33.1833 24.3599C33.1833 24.1446 33.1421 23.9391 33.0808 23.7344C32.5891 22.1559 30.8967 20.956 28.4563 20.7915V19.5098C28.4563 19.172 28.2516 18.9766 27.9436 18.9766ZM27.4309 23.0986V26.4824C25.995 26.1132 25.3904 25.5696 25.3904 24.7393C25.3904 23.9089 26.0878 23.222 27.4309 23.0986ZM28.4563 29.4355C30.0969 29.845 30.672 30.3071 30.6711 31.2197C30.6711 32.163 29.9333 32.8193 28.4563 32.9321V29.4355Z" />
		</svg>
	);
};

export default IconDollar;
